import $ from 'jquery'

export default class Accordions {

	constructor() {
		this.accordionTitle = $('.accordion .accordion-title')
	}

	init() {
		$(window).on('load', () => this.faqToggle());
	}

	faqToggle() {

		$('.header__cart__button--checkout').on('click', function(e) {
			e.preventDefault();
			$('.header__cart.is-showing').removeClass('is-showing');
		});

		this.accordionTitle.on('click', function(e) {
			e.preventDefault();

			var duration = 200;
			var accordion = $(this).closest('.accordion');
			var accordionItem = $(this).closest('.accordion__item');

			if ($(accordion).hasClass('accordion--multi-expand')) {

				$('.accordion-content', accordionItem).slideToggle(duration);
				$(accordionItem).toggleClass('is-active');

			} else {

				if ($(accordionItem).hasClass('is-active')) {

					$('.accordion-content').slideUp(duration);
                    $('.accordion__item').removeClass('is-active');
                    
				} else {

					$('.accordion-content').slideUp(duration);
					$('.accordion__item').removeClass('is-active');
					$('.accordion-content', accordionItem).slideDown(duration);
                    $(accordionItem).addClass('is-active');
                    
				}

			}

		});

	}


}